import { createSlice } from "@reduxjs/toolkit";

const globalSlice = createSlice({
  name: "global",
  initialState: {
    addModal: false,
    updateModal: false,
    updateId: null,
    bool: false,
    filter: false,
  },
  reducers: {
    toggleAddModal: (state) => {
      state.addModal = !state.addModal;  // Toggle show state
    },
    toggleUpdateModal: (state, action) => {
      state.updateId = action?.payload?.id
      state.updateModal = !state.updateModal;  // Toggle show state
    },
    toggleBool: (state) => {
      state.bool = !state.bool;  // Toggle bool state
    },
    toggleFilter: (state) => {
      state.filter = !state.filter;  // Toggle bool state
    },
    closeFilter: (state) => {
      state.filter = false;
    },
  },
});

// Export actions
export const { toggleAddModal, toggleUpdateModal, toggleBool, toggleFilter, closeFilter } = globalSlice.actions;

// Export reducer
export default globalSlice.reducer;